module.exports = function getResource(label, vars = []) {
    let resources = {
        colorIQMatches: 'Vos correspondances Color iQ',
        save: 'Sauvegarder'
    };

    return resources[label];
};
